<svg-icon *ngIf="src" [src]="src"
    [svgStyle]="{ 'width.px': width, 'height.px': height, 'stroke': stroke, 'fill': fill }" [svgAriaLabel]="label"
    [svgClass]="customClass" [stretch]="stretch" [viewBox]="viewBox"></svg-icon>